import React, { useState } from 'react';

const StoreLocator = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('all');

  const stores = [
    {
      id: 1,
      name: "Luxe Jewels Flagship - New York",
      address: "5th Avenue, New York, NY 10001",
      phone: "+1 (212) 555-0123",
      hours: "Mon-Sat: 10AM-8PM, Sun: 12PM-6PM",
      region: "north-east",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400",
      features: ["Personal Shopping", "3D Model Viewing", "Jewelry Care Services"]
    },
    {
      id: 2,
      name: "Luxe Jewels Beverly Hills",
      address: "Rodeo Drive, Beverly Hills, CA 90210",
      phone: "+1 (310) 555-0456",
      hours: "Mon-Sat: 10AM-7PM, Sun: 11AM-6PM",
      region: "west",
      image: "https://images.unsplash.com/photo-1555529669-e69e7aa0ba9a?w=400",
      features: ["VIP Appointments", "Custom Design", "Engagement Specialists"]
    },
    {
      id: 3,
      name: "Luxe Jewels Miami",
      address: "Lincoln Road, Miami Beach, FL 33139",
      phone: "+1 (305) 555-0789",
      hours: "Mon-Sat: 10AM-9PM, Sun: 11AM-7PM",
      region: "south",
      image: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?w=400",
      features: ["Evening Appointments", "Jewelry Repair", "Estate Jewelry"]
    },
    {
      id: 4,
      name: "Luxe Jewels Chicago",
      address: "Magnificent Mile, Chicago, IL 60611",
      phone: "+1 (312) 555-0321",
      hours: "Mon-Sat: 10AM-8PM, Sun: 12PM-6PM",
      region: "midwest",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400",
      features: ["Personal Styling", "Watch Services", "Gift Wrapping"]
    },
    {
      id: 5,
      name: "Luxe Jewels Dubai",
      address: "Dubai Mall, Dubai, UAE",
      phone: "+971 4 555 0666",
      hours: "Sat-Wed: 10AM-10PM, Thu-Fri: 10AM-12AM",
      region: "international",
      image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400",
      features: ["International Shipping", "Duty-Free", "Private Viewings"]
    },
    {
      id: 6,
      name: "Luxe Jewels London",
      address: "Bond Street, London, UK W1S 2UA",
      phone: "+44 20 5555 0999",
      hours: "Mon-Sat: 10AM-6PM, Sun: 12PM-5PM",
      region: "international",
      image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=400",
      features: ["Royal Warrant Holder", "Antique Collection", "Tea Service"]
    }
  ];

  const regions = [
    { value: 'all', label: 'All Locations' },
    { value: 'north-east', label: 'Northeast' },
    { value: 'south', label: 'South' },
    { value: 'midwest', label: 'Midwest' },
    { value: 'west', label: 'West Coast' },
    { value: 'international', label: 'International' }
  ];

  const filteredStores = stores.filter(store => {
    const matchesSearch = store.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         store.address.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesRegion = selectedRegion === 'all' || store.region === selectedRegion;
    return matchesSearch && matchesRegion;
  });

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <div className="luxury-container py-20">
        <h1 className="text-5xl font-bold text-center mb-4 hero-glow">FIND YOUR LUXE JEWELS</h1>
        <p className="text-center text-gray-400 mb-16 text-lg tracking-wide hover-glow">
          Discover our exclusive boutiques worldwide
        </p>

        {/* Search and Filter */}
        <div className="flex flex-col md:flex-row gap-6 mb-12 max-w-4xl mx-auto">
          <div className="flex-1">
            <input
              type="text"
              placeholder="Search by city or address..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full px-4 py-3 bg-gray-900 border border-yellow-600/30 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500/50"
            />
          </div>
          <div className="md:w-64">
            <select
              value={selectedRegion}
              onChange={(e) => setSelectedRegion(e.target.value)}
              className="w-full px-4 py-3 bg-gray-900 border border-yellow-600/30 rounded-lg text-white focus:outline-none focus:border-yellow-500 focus:ring-1 focus:ring-yellow-500/50"
            >
              {regions.map(region => (
                <option key={region.value} value={region.value} className="bg-gray-900">
                  {region.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Store Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredStores.map((store) => (
            <div key={store.id} className="bg-gray-900/50 rounded-lg overflow-hidden border border-yellow-600/20 hover:border-yellow-500/40 transition-all duration-300 hover-glow">
              <img src={store.image} alt={store.name} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-yellow-400 mb-2">{store.name}</h3>
                <p className="text-gray-300 mb-3 text-sm">{store.address}</p>
                <p className="text-gray-400 mb-2 text-sm"><span className="text-yellow-500">Phone:</span> {store.phone}</p>
                <p className="text-gray-400 mb-4 text-sm"><span className="text-yellow-500">Hours:</span> {store.hours}</p>

                <div className="mb-4">
                  <h4 className="text-yellow-400 font-medium mb-2">Exclusive Services:</h4>
                  <ul className="text-gray-300 text-sm space-y-1">
                    {store.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center">
                        <span className="text-yellow-500 mr-2">✦</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <button className="w-full bg-yellow-600 hover:bg-yellow-500 text-black font-semibold py-3 rounded transition-colors">
                  GET DIRECTIONS
                </button>
              </div>
            </div>
          ))}
        </div>

        {filteredStores.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No stores found matching your criteria.</p>
            <p className="text-gray-500 mt-2">Try adjusting your search or region filter.</p>
          </div>
        )}

        {/* Call to Action */}
        <div className="mt-20 text-center bg-gradient-to-r from-gray-900 via-gray-950 to-gray-900 py-12 rounded-lg border border-yellow-600/20">
          <h2 className="text-3xl font-bold text-yellow-400 mb-4">Experience Luxury In-Person</h2>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Visit one of our exclusive boutiques for a personalized shopping experience.
            Our expert consultants are ready to guide you through our finest collections.
          </p>
          <button className="bg-yellow-600 hover:bg-yellow-500 text-black font-semibold px-8 py-3 rounded transition-colors">
            SCHEDULE AN APPOINTMENT
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoreLocator;